import React from 'react'
import Stars from './Stars'
import NoBlanksBars from './NoBlanksBars'

export default function NoBlanks ({stars, percents}) {
  return (
    <div className="skill-box no-answers-blank ">
  		<div className="skill-information ">
	  		<h1 className="skill-name ">No Answers Blank</h1>
        <Stars stars={stars} />
        <p className="skill-description">
          There is no penalty for guessing on the ACT, so students should never leave an answer blank. This rating is based on the
          percentage of students who filled in every answer. The graphic shows the percentage of students who left no answers blank
          overall and in each subject area.
        </p>
      </div>
      <NoBlanksBars percents={percents} />
    </div>
  )
}


// WEBPACK FOOTER //
// ./src/components/Assessment/AssessPrint/TestTaking/NoBlanks.js